// 단위 목록 조회 훅(관리자).
// 단위는 DB 관리(마이그 0022)이며 화면마다 라벨/중량환산 표시에 필요하다.
// react-query 가 동일 queryKey 를 공유 캐시하므로 여러 컴포넌트에서 호출해도 1회만 가져온다.

import { useQuery } from "@tanstack/react-query";
import type { UnitDto } from "@oo/shared";
import { listUnitsAdmin } from "./catalogApi.ts";

// 단위 목록을 공유 캐시로 반환한다. 화면별 단위 라벨/중량환산 표시에 사용.
export function useUnits(): UnitDto[] {
  const { data = [] } = useQuery({
    queryKey: ["admin", "units"],
    queryFn: listUnitsAdmin,
    // 단위는 자주 바뀌지 않으므로 캐시를 오래 둔다.
    staleTime: 5 * 60 * 1000,
  });
  return data;
}
